module.exports = __webpack_public_path__ + "static/media/RG_WCS_0.b537f05d.jpg";